//@ts-check
import FileEditor from '../core/File/Editor';
export default FileEditor;